module.exports = __webpack_public_path__ + "static/media/disney.2e441abe.svg";